import { ActionTypes } from "./types";

let INITIAL_STATE = {
  loading: false,
  success: false,
  error: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.LOADING:
      return {
        ...state,
        loading: true
      };

    case ActionTypes.SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true
      };
    }

    case ActionTypes.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
